import React from 'react';

// Shared avatar: renders a profile photo when one exists, otherwise an
// initials chip on a coloured/gradient background. Sizing, rounding and the
// fallback background are passed in so it matches each surface's existing look.
//
//   <Avatar photo={s.profile_photo_url} firstName={s.first_name} lastName={s.last_name}
//           size="w-7 h-7" rounded="rounded-full" text="text-[10px] font-black"
//           gradient={`linear-gradient(135deg, ${c}bb, ${c})`} />
export default function Avatar({
  photo,
  firstName,
  lastName,
  name,
  size = 'w-10 h-10',
  rounded = 'rounded-full',
  text = 'text-sm font-bold',
  gradient,
  className = '',
}) {
  const initials =
    ((firstName?.[0] || '') + (lastName?.[0] || '')) ||
    (name ? name.trim().split(/\s+/).map((w) => w[0]).slice(0, 2).join('') : '') ||
    '?';
  const base = `${size} ${rounded} shrink-0 overflow-hidden ${className}`;

  if (photo) {
    return (
      <img
        src={photo}
        alt={name || `${firstName || ''} ${lastName || ''}`.trim() || 'Profile photo'}
        className={`${base} object-cover bg-slate-100`}
      />
    );
  }
  return (
    <div
      className={`${base} flex items-center justify-center text-white ${text}`}
      style={gradient ? { background: gradient } : undefined}
    >
      {initials.toUpperCase()}
    </div>
  );
}
